import { render, staticRenderFns } from "./LayoutRss.vue?vue&type=template&id=72919d16&"
import script from "./LayoutRss.vue?vue&type=script&lang=js&"
export * from "./LayoutRss.vue?vue&type=script&lang=js&"
import style0 from "./LayoutRss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports